import { _APIHandler } from "../utils/helper";

let baseUrl = "profile";
export const fetchProfile = () => _APIHandler.get(`${baseUrl}`);
export const updateProfile = (data) => _APIHandler.put(`${baseUrl}`, data);
export const changePassword = (data) => _APIHandler.put(`${baseUrl}/password/change`, data);